import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { axios } from 'lib'
import { OrdersStatus } from 'modules/orders/types'

const loadOrdersStatus = (
  data: PaginatedParams
): PaginatedResponse<OrdersStatus> => {
  const { page = 1, limit = 100 } = data
  return axios.get('/orders/status', {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrdersStatus(query: any) {
  return useQuery(['ordersStatus', query], () => loadOrdersStatus(query), {
    keepPreviousData: true,
    onError: () => {
      toast.error('Não foi possível carregar os controles!', {
        toastId: 'laodOrdersStatus'
      })
    }
  })
}
